import { defineStore } from "pinia";
import type { reservedDate } from "@/models/ReservedDate";
import { setRegisterAs } from "@/services/tracking";

export const useUserStore = defineStore("user", {
  state: () => ({
    isLoggedIn: false,
    id: "",
    role: null as "jugendlicher" | "bauernfamilie" | null,
    name: "",
    firstName: "",
    username: "",
    email: "",
    profil: null as any,
    hasProfilePropertiesFilled: true,
    reservedDates: [] as reservedDate[],
  }),
  actions: {
    setUser(userData: {
      id: string;
      role: "jugendlicher" | "bauernfamilie" | null;
      name: string;
      firstName: string;
      username: string;
      email: string;
      profil: any;
      hasProfilePropertiesFilled: boolean;
      reservedDates: reservedDate[];
    }) {
      this.isLoggedIn = true;
      this.id = userData.id;
      this.role = userData.role;
      this.name = userData.name;
      this.firstName = userData.firstName;
      this.username = userData.username;
      this.email = userData.email;
      this.profil = userData.profil;
      this.hasProfilePropertiesFilled = this.importantProfilePropertiesFilled();
      this.reservedDates = userData.reservedDates;
      // GTM: keep register_as readable for as long as the user is logged in.
      // Set here rather than at the call sites so login, session restore and
      // profile updates all stay in sync with the role in the store.
      setRegisterAs(this.role);
    },
    clearUser() {
      this.isLoggedIn = false;
      this.id = "";
      this.role = null;
      this.name = "";
      this.firstName = "";
      this.username = "";
      this.email = "";
      this.profil = null;
      this.hasProfilePropertiesFilled = true;
      this.reservedDates = [];
      // GTM: unset register_as so no value survives a logout in the same tab.
      setRegisterAs(null);
    },
    setUserProfile(data: any) {
      this.profil = data;
    },

    // New action to check if specific profile properties are filled
    importantProfilePropertiesFilled(): boolean {
      if (!this.profil || this.role === "bauernfamilie") return true;

      const {
        vorname,
        nachname,
        geschlecht,
        geburtsdatum,
        telefonMobile,
        nationalitaet,
        korrespondenzsprache,
        sprachkenntnisDE,
        sprachkenntnisFR,
        sprachkenntnisIT,
      } = this.profil;
      const { strasseNr, plz, ort, landId } = this.profil.adresse || {};

      const values = [
        vorname,
        nachname,
        geschlecht,
        geburtsdatum,
        strasseNr,
        plz,
        ort,
        landId,
        telefonMobile,
        nationalitaet,
        korrespondenzsprache,
        sprachkenntnisDE,
        sprachkenntnisFR,
        sprachkenntnisIT,
      ];

      return values.every((value) => {
        console.log(value);
        console.log(
          typeof value === "string" ? value.trim() !== "" : value != null
        );
        return typeof value === "string" ? value.trim() !== "" : value != null;
      });
    },
  },
  persist: true,
});
